import orderCompleteLottie from '~/components/media/order-complete.json'
import orderProblemLottie from '~/components/media/order-problem.json'

type LottieNames = 'order-complete' | 'order-problem'

export const getLottieFile = (type: LottieNames): string | null => {
  switch (type) {
    case 'order-complete': {
      return JSON.stringify(orderCompleteLottie)
    }
    case 'order-problem': {
      return JSON.stringify(orderProblemLottie)
    }
    default:
      return null
  }
}
